import React, { useEffect, useState } from 'react';
import { Link, useParams } from "react-router-dom";
import { Card, Col, Container, Row } from 'reactstrap';
import axios from 'axios';
import Swal from 'sweetalert2';
import AuthSlider from './authCarousel';

const ChangePassword = () => {
    const [errorMessage, setErrorMessage] = useState('');
    const [showMessage, setShowMessage] = useState(false);
    const [displayForm, setDisplayForm] = useState(true);
    const [users, setUsers] = useState({
        token: '',
        password: '',
        password_confirmation: ''
    });

    const [criteria, setCriteria] = useState({
        length: false,
        uppercase: false,
        number: false
    });

    const { token } = useParams();

    useEffect(() => {
        document.title = "Alteração de Senha | Plantão Rápido";

        if (token) {
            setUsers(prevUsers => ({
                ...prevUsers,
                token: token
            }));
        }
    }, [token]);

    const handleChange = (event) => {
        const { name, value } = event.target;
        setUsers(prevUsers => ({
            ...prevUsers,
            [name]: value
        }));

        if (name === 'password') {
            validatePassword(value);
        }
    };

    const validatePassword = (password) => {
        setCriteria({
            length: password.length >= 6,
            uppercase: /[A-Z]/.test(password),
            number: /[0-9]/.test(password)
        });
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        if (users.password !== users.password_confirmation) {
            Swal.fire({
                icon: 'error',
                title: 'Erro',
                text: 'As senhas não coincidem. Por favor, tente novamente.'
            });
            return;
        }

        if (!criteria.length || !criteria.uppercase || !criteria.number) {
            setErrorMessage('A senha deve atender a todos os critérios.');
            setShowMessage(false);
            return;
        }

        axios.post(process.env.REACT_APP_URL_API + 'password/reset', users)
            .then(() => {
                setShowMessage(true);
                setDisplayForm(false);
                setErrorMessage('');
            })
            .catch(error => {
                const responseData = error.response?.data;
                const message = responseData?.message || 'Erro desconhecido';
                const errors = responseData?.data?.errors;

                if (errors && errors.length > 0) {
                    setErrorMessage(errors.join('\n'));
                } else {
                    setErrorMessage(message);
                }

                setShowMessage(false);
            });
    };

    return (
        <React.Fragment>
            <div className="auth-page-wrapper auth-bg-cover py-5 d-flex justify-content-center align-items-center min-vh-100">
                <div className="bg-overlay"></div>

                <div className="auth-page-content overflow-hidden pt-lg-5">
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <Card className="overflow-hidden">
                                    <Row className="g-0">
                                        <AuthSlider />
                                        <Col lg={6}>
                                            <div className="p-lg-5 p-4">
                                                <div className="login-back mb-4">
                                                    <a href="https://www.plantaorapido.com.br/" className="text-decoration-none">
                                                        <i className="fa-solid fa-arrow-left-long me-2" /> Home
                                                    </a>
                                                </div>
                                                <h5 className="text-primary">Alterar Senha de Acesso</h5>
                                                <p className="text-muted">
                                                    Digite sua nova senha para continuar utilizando a plataforma.
                                                </p>

                                                {showMessage && (
                                                    <>
                                                    <div className="alert alert-primary mt-3" role="alert">
                                                        Senha alterada com sucesso!
                                                    </div>
                                                    <div className="form-group mt-2">
                                                    <a className="btn btn-light w-100" href="/login">
                                                    <i className="fa-solid fa-arrow-left me-2" /> Voltar Login
                                                    </a>
                                                    </div>
                                                    </>
                                                )}

                                                {errorMessage && (
                                                    <div className="alert alert-danger mt-3" role="alert">
                                                        {errorMessage}
                                                    </div>
                                                )}

                                                {displayForm && (
                                                    <form onSubmit={handleSubmit}>
                                                        <div className="form-group">
                                                            <label>Nova Senha</label>
                                                            <input
                                                                type="password"
                                                                name="password"
                                                                onChange={handleChange}
                                                                className="form-control"
                                                            />
                                                        </div>

                                                        <ul className="password-criteria list-unstyled my-3">
                                                            <li className={criteria.length ? "text-success" : "text-danger"}>
                                                                <i className={`fa ${criteria.length ? "fa-check" : "fa-times"}`}></i> Mínimo de 6 caracteres
                                                            </li>
                                                            <li className={criteria.uppercase ? "text-success" : "text-danger"}>
                                                                <i className={`fa ${criteria.uppercase ? "fa-check" : "fa-times"}`}></i> Pelo menos 1 letra maiúscula
                                                            </li>
                                                            <li className={criteria.number ? "text-success" : "text-danger"}>
                                                                <i className={`fa ${criteria.number ? "fa-check" : "fa-times"}`}></i> Pelo menos 1 número
                                                            </li>
                                                        </ul>

                                                        <div className="form-group">
                                                            <label>Confirme a Senha</label>
                                                            <input
                                                                type="password"
                                                                name="password_confirmation"
                                                                onChange={handleChange}
                                                                className="form-control"
                                                            />
                                                        </div>
                                                        <div className="form-group mt-4">
                                                            <button className="btn btn-primary w-100" type="submit">
                                                                Alterar Senha
                                                            </button>
                                                        </div>

                                                        <div className="form-group mt-2">
                                                            <a className="btn btn-light w-100" href="/login">
                                                                <i className="fa-solid fa-arrow-left me-2" /> Voltar Login
                                                            </a>
                                                        </div>
                                                    </form>
                                                )}
                                            </div>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>

                <footer className="footer">
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <div className="text-center">
                                    <p className="mb-0">
                                        &copy; {new Date().getFullYear()}{" "}
                                        <a
                                            className="text-reset text-decoration-none"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            href="https://medr.com.br/"
                                        >
                                            MEDR
                                        </a>. Todos os direitos reservados.
                                    </p>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </footer>
            </div>
        </React.Fragment>
    );
};

export default ChangePassword;
